<template>
    <div :class="isWide ? '' : additionalClasses">
        <div
            :class="['row mb-2 p-md-1', isSosh ? 'text-dark' : 'text-white', isSosh ? 'bg-gray2' : 'bg-dark']"
        >
            <div class="col-12 col-md-2 d-flex justify-content-center align-items-md-center">
                <img
                    :src="image"
                    alt="logo 5G"
                    class="alert-icon logo-tuile-5g  py-1 py-md-0"
                >
            </div>
            <div class="col-12 col-md-6">
                <div class="h4 pt-1 pt-md-2 pb-0 mb-0 ps-0">
                    {{ title }}
                </div>
                <ob1-liste-a-puces
                    :liste-a-puces-dto="list"
                />
            </div>
            <div class="col-12 col-md-4 d-flex justify-content-center align-items-md-center pb-2 pb-md-0">
                <ob1-boutons
                    :label="link.text"
                    :target="link.target"
                    :href="link.href"
                    :is-button="false"
                    is-inverse
                    is-secondary
                    data-oevent-category="zone_info_5g"
                    :data-oevent-action="getLabelToTmsFormat(link.text)"
                    :data-oevent-label="link.href"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        link: {
            type: Object,
            required: true
        },
        list: {
            type: Object,
            required: true
        },
        image: {
            type: String,
            required: true
        },
        isWide: {
            type: Boolean,
            default: false
        },
        additionalClasses: {
            type: String,
            default: ""
        },
        isSosh: {
            type: Boolean,
            required: true
        },
    },
    methods: {
        handleClick(event) {
            event.preventDefault();
            if (this.link.tmsDTO !== undefined) {
                Tms.link({
                    category: this.link.tmsDTO.tagZone,
                    action: this.link.tmsDTO.tagName,
                    label: this.link.tmsDTO.tagTarget
                })
            }
            window.location = this.link.href;
        },
        getLabelToTmsFormat(label) {
            return stripAccents(label).split(' ').join('_');
        },

    }
}
</script>

<style lang="scss">
@import 'ob1_common', 'ob1_variables';
.logo-tuile-5g {
    width: px-to-rem(52);
    @media (min-width: #{map-get($grid-breakpoints, md)}) {
        width: px-to-rem(135);
    }
}
//cutomise pour le lien qui vient edithor est en noir par défaut
.white-link {
    a {
        color: white;
    }
}
</style>

